import { Route, Routes } from "react-router-dom";
import App from "./App";
import CreditApplicationForm from "./components/CreditApplication/CreditApplicationForm";
import Login from "./components/Login/LoginComp";
import PrivacyPolicy from "./components/PrivacyPolicy";
import * as Navigation from "./constants/routes";
import GdpTraining from "./features/GdpTraining";
import PPERequirements from "./features/PPERequirements";
import RiskAssessment from "./features/RiskAssessment";
import SafetyAlert from "./features/SafetyAlert";
import SwiftTrafficSignup from "./features/SwiftTrafficSignup";
import SafeOperatingProcedure from "./features/SafeOperatingProcedure";
import InboundContainer from "./features/InboundContainer";
import UseOfMobilePhonePolicySignup from "./features/UseOfMobilePhonePolicySignup";
import AcnDriver from "./features/ACNSignUp";

const routes = [
  { path: Navigation.LOGIN, element: <Login /> },
  { path: Navigation.PRIVACY_POLICY, element: <PrivacyPolicy /> },
  {
    path: Navigation.CREDIT_APPLICATION_MODAL,
    element: <CreditApplicationForm />,
  },
  {
    path: Navigation.CREDIT_APPLICATION_WITH_ID,
    element: <CreditApplicationForm />,
  },
  {
    path: Navigation.VIEW_CREDIT_APPLICATION_WITH_ID,
    element: <CreditApplicationForm />,
  },
  {
    path: Navigation.SWIFT_TRAFFIC_SIGNUP,
    element: <SwiftTrafficSignup />,
  },
  {
    path: Navigation.RISK_ASSESSMENT_SIGNUP,
    element: <RiskAssessment />,
  },
  {
    path: Navigation.SAFETY_ALERT_SIGNUP,
    element: <SafetyAlert />,
  },
  {
    path: Navigation.PPE_REQUIREMENTS,
    element: <PPERequirements />,
  },
  {
    path: Navigation.GDP_TRAINING,
    element: <GdpTraining />,
  },
  {
    path: Navigation.SAFE_OPERATING_PROCEDURE,
    element: <SafeOperatingProcedure />,
  },
  {
    path: Navigation.INBOUND_CONTAINER,
    element: <InboundContainer />,
  },
  {
    path: Navigation.USE_OF_MOBILE_PHONE_POLICY_SIGNUP,
    element: <UseOfMobilePhonePolicySignup />,
  },
  {
    path: Navigation.ACN_DRIVER_SIGNUP,
    element: <AcnDriver />,
  },
  { path: "*", element: <App /> },
];

const AppRoutes = () => {
  return (
    <Routes>
      {routes.map((route, index) => (
        <Route key={index} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
};

export default AppRoutes;
